import React, { Component, useRef  } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { editorService } from "../Services/EditorService.js";
import { orderService } from "../Services/OrderService.js";
import { tmxService } from "../Services/TmxService.js";
//import EditorSegments from "../Components/Editor/EditorSegments";
//import Context from "../Components/Editor/Context";
import EditorRow from "../Components/Editor/EditorRow.js";
import TmxSearch from "../Components/Editor/TmxSearch";
import FullText from "../Components/Editor/FullText.js";
import Documentation from "../Components/Editor/Documentation.js";
import SegmentDiff from "../Components/Editor/SegmentDiff.js";
import EditorSearch from "../Components/Editor/EditorSearch.js";
import '../Styles/editor.css';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import FinalizeIcon from '@material-ui/icons/Save';
import SaveIcon from '@material-ui/icons/SaveOutlined';
import InvisibleIcon from '@material-ui/icons/VisibilityOffOutlined';
import NavigateNext from '@material-ui/icons/NavigateNext';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import CodeIcon from '@material-ui/icons/Code';
import GridOffIcon from '@material-ui/icons/GridOff';
import { borders } from '@material-ui/system';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import {denormalizerService} from "../Services/denormalizerService.js";
import QAErrorSlide from "../Components/QA/QAErrorSlide";
import { qaService } from "../Services/QAService.js";

import Slider from '@material-ui/core/Slider';

import * as editorActions from '../Actions/editorActions';

class EditorContainer extends Component {
	constructor(props) {
		super(props);
		this.onChangeContext = this.onChangeContext.bind(this);
		this.onChangeTextMarca = this.onChangeTextMarca.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.handlePrev = this.handlePrev.bind(this);
		this.updateSegment = this.updateSegment.bind(this);
		this.updateSpellError = this.updateSpellError.bind(this);
		this.seleccionaTag = this.seleccionaTag.bind(this);
		this.handleKey = this.handleKey.bind(this);
		this.switchCarInv = this.switchCarInv.bind(this);
		this.switchReplaceRepetitions = this.switchReplaceRepetitions.bind(this);
		this.calculaIndexSegments = this.calculaIndexSegments.bind(this);
		this.cercaIndexSegment = this.cercaIndexSegment.bind(this);
		this.guardar = this.guardar.bind(this);
		this.guardarP = this.guardarP.bind(this);
		this.finalizar = this.finalizar.bind(this);
		this.spellcheck = this.spellcheck.bind(this);
		this.downloadTmx = this.downloadTmx.bind(this);
		this.updateRepetitions = this.updateRepetitions.bind(this);
		this.gotoCurrentSpellError = this.gotoCurrentSpellError.bind(this);
		this.handleGotoSegment = this.handleGotoSegment.bind(this);
		this.handleGotoSegmentIndex = this.handleGotoSegmentIndex.bind(this);
		this.handleGotoError = this.handleGotoError.bind(this);
		this.traspassaSegment = this.traspassaSegment.bind(this);
		this.search = this.search.bind(this);
		this.replace = this.replace.bind(this);
		this.marcar = this.marcar.bind(this);
		this.marcarGuardar = this.marcarGuardar.bind(this);
		this.execMarcar = this.execMarcar.bind(this);
		this.desmarcar = this.desmarcar.bind(this);
		this.getIndexSegment = this.getIndexSegment.bind(this);
		this.validaSegment = this.validaSegment.bind(this);
		this.wheel = this.wheel.bind(this);
		this.handleSliderChange = this.handleSliderChange.bind(this);
		this.comprovaTags = this.comprovaTags.bind(this);
		this.onTimer = this.onTimer.bind(this);
		this.desbloquejaSegment = this.desbloquejaSegment.bind(this);
		
		
		var wheelTimeout;
		var timer;
		
		this.state={
			tagSeleccionat: -1,
			showInvChars: 0,
			indexSegments: Array(),
//			tmx: null,
			tmxMatch: null,
			repetitions: null,
			spellErrors: null,
			currentSpellError: 0,
			focus: "",
			contextShown: 3,
			textMarca: "",
			processing: 0,
			foundSegments: [],
			editorPois: [],
			editantParaula: false,
			qaErrors: [],
			showQaErrors: true,
			glossary: null,
			replaceRepetitions: 1,
			translatedWords:{
				noves: 0,
				rep:   0,
				m100:  0,
				m75:   0
			}
		}
	}

	componentDidMount() {
//		console.log("EditorContainer componentDidMount");
		this.timer = setTimeout(this.onTimer, 300000);
		editorService.getXliff(this.props.user.access_token, this.props.match.params.idDoc)
					.then( response => {return this.props.actions.getXLIF(response.data);})
					.then( ()=>{return editorService.parseXliff(this.props.editor.xliff);})
					.then( (TUs)=>{return editorService.matchSubstituition(TUs);})
					//.then( (TUs)=>{return this.props.actions.updateXLIF(TUs);})
					.then( (TUs)=>{ this.calculaIndexSegments(TUs);
									let repetitions = editorService.searchRepetitions(TUs);
									let translatedWords = editorService.recomptaParaules(TUs, repetitions);
									this.setState({repetitions: repetitions, translatedWords: translatedWords});
									editorService.setDistance(TUs);
									return this.props.actions.getSegments(TUs);
									})
					.then( ()=>{return orderService.getTmxMatch(this.props.orderRecord.id)})
					.then(tmxMatch => {this.setState({tmxMatch: tmxMatch.data.find( match => {return match.target === 'TRANSLATOR';})}); return 1;})
					.then( ()=>{return editorService.getEditorPois(this.props.orderRecord.id)})
					.then(response => {this.setState({editorPois: response.data}); return 1;})
					.then( ()=> editorService.getGlossary(this.props.customerRecord.id, this.props.langPair.id))
					.then(response => this.setState({glossary: editorService.parseGlossary(response.data)}))
					.then( ()=> qaService.listErrors(this.props.orderRecord.id))
					.then(response => {return this.setState({qaErrors: response.data});})
					.catch(err => {/*console.log(err);*/});
	}
	
	componentWillUnmount(){
		this.props.actions.setTmx([]);
		clearTimeout(this.timer);
	}
	
	onTimer(){
		if(this.props.user.role!=='ADMIN' && this.props.user.switch_user===""){
			this.guardar();
		}
	}
	
	onChangeContext(e){
		//if(parseInt(e.target.value, 10)>0 && parseInt(e.target.value, 10)<10){
		if( (parseInt(e.target.value, 10)>0) && (parseInt(e.target.value, 10)<100) ){
			this.setState({contextShown: parseInt(e.target.value, 10)});
		}
	}
	onChangeTextMarca(e){
		this.setState({textMarca: e.target.value});
	}
	
	guardar(){
		clearTimeout(this.timer);
		let xliff=editorService.regeneraXliff(this.props.editor.xliff, this.props.editor.TUs);
		this.props.actions.updateXLIF(xliff);
		let progres = editorService.calculaProgres(this.props.editor.TUs);
		let denormlaizedOrder = denormalizerService.orderDenormalizer(this.props.orderRecord);
		denormlaizedOrder.progres=progres;
		this.timer = setTimeout(this.onTimer, 300000);
		return editorService.sendXliff(this.props.match.params.idDoc, xliff).then(orderService.updateOrderForm(denormlaizedOrder));
	}
	guardarP(){
		this.setState({processing: 1});
		this.guardar().then(() =>{this.setState({processing: 0}); return 1;})
					.then(() => {this.marcarGuardar(); return 1;})
					//.then(() => {editorService.comprovaTags(this.props.editor.TUs, this.state.editorPois, this.props.orderRecord.id); return 1})
					.then(() => {this.comprovaTags(); return 1})
					.catch(err => {this.setState({processing: 0});});
	}
	
	comprovaTags(){
		//editorService.comprovaTags(this.props.editor.TUs, this.state.editorPois, this.props.orderRecord.id);
		//let response = Promise.resolve(editorService.getEditorPois(this.props.orderRecord.id));
		//console.log(response)
		//this.setState({editorPois: response.data}, function(){ console.log(this.state.editorPois) });
		editorService.comprovaTags(this.props.editor.TUs, this.state.editorPois, this.props.orderRecord.id)
			.then(() => {return editorService.getEditorPois(this.props.orderRecord.id);})
			.then(response => {this.setState({editorPois: response.data}); return 1;})
			.catch(err => {});
	}
	
	finalizar(){
		this.setState({processing: 1});
//		console.log(this.props.orderRecord.state);
		if(this.props.orderRecord.state=="REVISION"){
//			console.log("Revision branch");
			this.guardar().then(() => {return orderService.finishRevisionTask(this.props.match.params.idOrder, 1);})
//						.then(response => { return this.props.history.push('/qaList/'+this.props.match.params.idOrder);})
						.then(response => { return this.props.history.push('/orderList');})
						.catch(err => {this.setState({processing: 0}); });
		}else{
			this.guardar().then(() => {return orderService.finishOrderTask(this.props.match.params.idOrder, 1);})
//						.then(response => { return this.props.history.push('/qaList/'+this.props.match.params.idOrder);})
						.then(response => { return this.props.history.push('/orderList');})
						.catch(err => {this.setState({processing: 0}); });
		}
	}
	
	gotoCurrentSpellError(){
		//console.log("gotoCurrentSpellError: "+this.state.currentSpellError+"(tu: "+this.state.spellErrors[this.state.currentSpellError].iTu+", seg: "+this.state.spellErrors[this.state.currentSpellError].iSeg+")");
		this.props.actions.gotoSegment(this.state.spellErrors[this.state.currentSpellError].iTu, this.state.spellErrors[this.state.currentSpellError].iSeg);
	}
				
	spellcheck(){
		if(this.state.spellErrors===null  && this.state.showInvChars===0){
//			console.log(this.props.langPair);
			let language = this.props.langPair.code.split("-")[1].split("_")[0];
//			console.log("Activa SpellCheck per: "+language);
			let resp = editorService.spellCheck(language, this.props.editor.TUs)
						.then(response => { return editorService.parseSpellCheckResp(this.props.editor.TUs, response.data);})
						.then(response => { this.setState({spellErrors: response}); this.setState({currentSpellError: 0}); return 1;})
						.then(response => { this.gotoCurrentSpellError(); return 1;})
						.catch(err => {/*console.log(err);*/});
//			console.log(resp);
		}else{
			//console.log("Desactiva SpellCheck");
			this.setState({spellErrors: null, currentSpellError: 0});
		}
	}
	
	calculaIndexSegments(TUs){
		var iTu;
		var iSeg;
		var indexSegments=Array();
		
		for(iTu=0; iTu<TUs.length; iTu++){
			for(iSeg=0; iSeg<TUs[iTu].segments.length; iSeg++){
				indexSegments.push({iTu: iTu, iSeg: iSeg});
			}
		}
		this.setState(
			{indexSegments: indexSegments}
		);
	}
	
	getIndexSegment(iTu, iSeg){
//		console.log("getIndexSegment: "+iTu+","+iSeg);
		let count=0;
		for(let i=0; i<iTu; i++){
			count += this.props.editor.TUs[i].segments.length;
//			console.log("count per TU["+i+"]: "+count)
		}
//		console.log("count per TUs: "+count);
//		console.log("count: "+count+iSeg);
		return count+iSeg;
	}
	
	cercaIndexSegment(iTu, iSeg){
		let i=0;
		let trobat=false;
		while(i<this.state.indexSegments.length && !trobat){
			if(this.state.indexSegments[i].iTu == iTu && this.state.indexSegments[i].iSeg == iSeg){
				trobat=true;
			}else{
				i++;
			}
		}
		if(trobat){
			return i;
		}else{
			return 0;
		}
	}
	
	switchReplaceRepetitions(){
		if(this.state.replaceRepetitions>0){
			this.setState(
				{replaceRepetitions: 0}
			);
		}else{
			this.setState(
				{replaceRepetitions: 1}
			);
		}
	}
	
	switchCarInv(){
		if(this.state.showInvChars>0){
			this.setState(
				{showInvChars: 0}
			);
		}else if(this.state.spellErrors===null){
			this.setState(
				{showInvChars: 1}
			);
		}
//		console.log("switchCarInv("+this.state.showInvChars+")");
	}
	
	handleNext(){
		//console.log("handleNext()");
		//if(this.state.spellErrors===null){
		if(this.state.editantParaula===false){
			this.setState({tagSeleccionat: -1});
			this.props.actions.nextSegment();
		}else{
			//console.log("handleNext() currentSpellError(1):"+this.state.currentSpellError+"/"+this.state.spellErrors.length);
			if((this.state.currentSpellError+1)<this.state.spellErrors.length){
				this.setState((state) => {
					return {currentSpellError: state.currentSpellError + 1}
					//return {...state, [currentSpellError]: state.currentSpellError + 1}
				});
				//console.log("handleNext() currentSpellError(2):"+this.state.currentSpellError);
				//this.gotoCurrentSpellError();
				this.props.actions.gotoSegment(this.state.spellErrors[this.state.currentSpellError+1].iTu, this.state.spellErrors[this.state.currentSpellError+1].iSeg);
			}
		}
	}
	
	handlePrev(){
		//if(this.state.spellErrors===null){
		if(this.state.editantParaula===false){
			this.setState(
				{tagSeleccionat: -1}
			);
			this.props.actions.previousSegment();
		}else{
			if(this.state.currentSpellError>0){
				this.setState({currentSpellError: this.state.currentSpellError-1});
				this.props.actions.gotoSegment(this.state.spellErrors[this.state.currentSpellError-1].iTu, this.state.spellErrors[this.state.currentSpellError-1].iSeg);
			}
		}
	}
	
	handleGotoSegment(iTu, iSeg){
		//if(this.state.spellErrors===null){
		this.setState({editantParaula: false});
		//if(this.state.editantParaula===false){
			this.setState(
				{tagSeleccionat: -1}
			);
			this.props.actions.gotoSegment(iTu, iSeg);
		//}
	}
	handleGotoError(iTu, iSeg, indexError){
		//console.log("Editor.gotoError: " + iTu+","+iSeg+","+indexError);
		this.setState(
			{tagSeleccionat: -1}
		);
		this.setState({editantParaula: true, currentSpellError: indexError});
		this.props.actions.gotoSegment(iTu, iSeg);
	}
	
	handleGotoSegmentIndex(index){
		this.props.actions.gotoSegment(this.state.indexSegments[index].iTu, this.state.indexSegments[index].iSeg);
	}
	
	updateSegment(segmentMod, index){
		//console.log("updateSegment: "+JSON.stringify(segmentMod));
		if(this.state.replaceRepetitions>0){
			this.updateRepetitions(segmentMod);
		}
		//this.props.actions.updateCurrentSegment(segmentMod,this.state.indexSegments[index].iTu, this.state.indexSegments[index].iSeg);
		this.props.actions.updateSegment(segmentMod,this.state.indexSegments[index].iTu, this.state.indexSegments[index].iSeg);
	}
	
	traspassaSegment(index, from){
//		console.log("traspassaSegment: "+index+" from:"+from);
		if( this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg]["trg"].state!=="blocked" &&
			typeof(this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg][from])!=='undefined'){
			let lstSegmentsMod=JSON.parse(JSON.stringify(this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg]));
			lstSegmentsMod["trg"]=JSON.parse(JSON.stringify(this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg][from]));
			lstSegmentsMod["trg"].state= "new"
			this.updateSegment(lstSegmentsMod, index);
		}
	}
	
	updateSpellError(segmentMod, spellErrors){
		//console.log("updateSpellError: "+JSON.stringify(spellErrors));
		//console.log("spellErrors Before: "+JSON.stringify(this.state.spellErrors));
		
		//let spellErrorsNew=this.state.spellErrors;
		//let j=0;
		//for(let i=0; i<this.state.spellErrors.length; i++){
		//	if( (this.state.spellErrors[i].iTu == this.state.indexSegments[i].iTu)&&(this.state.spellErrors[i].iSeg == this.state.indexSegments[i].iSeg)){
		//		spellErrorsNew[i]=spellErrors[j];
		//		j++;
		//	}
		//}
		//this.setState(
		//	{spellErrors: spellErrorsNew}
		//);
		//console.log("spellErrors After: "+JSON.stringify(spellErrorsNew));
		this.props.actions.updateCurrentSpellError(segmentMod, spellErrors);
	}
	
	updateRepetitions(segmentOrg){
		if( typeof(this.state.repetitions.target[this.props.editor.current.iTu])!=="undefined" &&
			typeof(this.state.repetitions.target[this.props.editor.current.iTu][ this.props.editor.current.iSeg]!="undefined") && 
			this.state.repetitions.target[this.props.editor.current.iTu][ this.props.editor.current.iSeg]!=null){
				
//				this.state.repetitions.target[this.props.editor.current.iTu][this.props.editor.current.iSeg].forEach(function(rep) {
				for(let i=0; i<this.state.repetitions.target[this.props.editor.current.iTu][this.props.editor.current.iSeg].length; i++){
					let rep =this.state.repetitions.target[this.props.editor.current.iTu][this.props.editor.current.iSeg][i];
					//console.log("Substitueix repeticio "+this.props.editor.current.iTu+","+this.props.editor.current.iSeg+">"+JSON.stringify(rep)+"");
					let segmentMod = this.props.editor.TUs[rep.tu].segments[rep.seg];
					segmentMod["trg"].text=segmentOrg["trg"].text;
					if(segmentMod["trg"].tags.length==segmentOrg["trg"].tags.length){
						for(let j=0; j<segmentOrg["trg"].tags.length; ++j){
							//console.log("mou tag "+j);
							segmentMod["trg"].tags[j].position=segmentOrg["trg"].tags[j].position;
						}
					}
					//console.log("updateSegment(segmentMod, "+rep.tu+", "+rep.seg+"):"+JSON.stringify(segmentMod));
					this.props.actions.updateSegment(segmentMod, rep.tu, rep.seg) ;
				}
		}
	}
	
	seleccionaTag(tagIndex){
		this.setState(
			{tagSeleccionat: tagIndex}
		);
	}
	
	downloadTmx(){
		tmxService.findTmx(this.props.customerRecord.id, this.props.orderRecord.langPair)
					.then( response => {return tmxService.downloadTmx(response.data.id);})
					.then( response => {return tmxService.parseTmx(response.data);})
					.then( tmx => { return this.props.actions.setTmx(tmx);})
					.then( a => { this.setState({focus: "tmx"}); return 1;})
					//.then( (tmx) => { this.setState({tmx: tmx, focus: "tmx"}); return 1;})
					//.then( response => {/*console.log("TMX: "+JSON.stringify(response));*/ return 1;})
					.catch(err => {/*console.log(err);*/});
	}
	
	handleKey(e){
		if (e.keyCode === 9){
			e.stopPropagation();
			e.preventDefault();
			if(e.altKey){
				this.handlePrev();
			}else{
				this.handleNext();
			}
		}
	}
	
	search(searchValue){
		let i=0;
		let found = [];
		if(searchValue.length>0){
			for(i=0; i<this.state.indexSegments.length; i++){
				//console.log("search:"+i);
				//console.log(this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["src"].text);
				if( this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["src"].text.toLowerCase().includes(searchValue.toLowerCase()) ||
					this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["trg"].text.toLowerCase().includes(searchValue.toLowerCase())){
					found.push(i);
				}
			}
		}
		this.setState({ foundSegments: found });
		if(found.length>0){
//			console.log(found);
			this.handleGotoSegmentIndex(found[0]);
		}
	}
	
	replace(searchValue, replaceValue){
		let i=0;
		let found = [];
		if((searchValue.length>0) && (replaceValue.length>0)){
			for(i=0; i<this.state.indexSegments.length; i++){
				//let lstSegmentsMod=this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg];
				let lstSegmentsMod = JSON.parse(JSON.stringify(this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]))
				lstSegmentsMod["trg"].text = lstSegmentsMod["trg"].text.replace(searchValue, replaceValue);
				if(this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["trg"].text !== lstSegmentsMod["trg"].text){
//					console.log("--> replaced at: "+i+" <--");
					found.push(i);
					this.updateSegment(lstSegmentsMod, i);
				}
			}
		}
		this.setState({ foundSegments: found });
			
//		if(found.length>0){
//			console.log(found);
//			this.handleGotoSegmentIndex(found[0]);
//		}
	}
	
	marcar(e){
		this.execMarcar("marca", this.state.textMarca);
		this.setState({textMarca: ""});
	}
	
	marcarGuardar(){
//		console.log("Marca SAVE");
		if(typeof(this.state.editorPois)!="undefined"){
			let poiSave = this.state.editorPois.find(poi => poi.name=="SAVE");
			if(typeof(poiSave)!="undefined"){
//				console.log("Marca SAVE: "+poiSave.id);
				editorService.deleteEditorPoi(poiSave.id);
			}
		}
		this.execMarcar("SAVE", "SAVE");
	}
	
	execMarcar(name, description){
//		console.log("marcar: "+this.props.editor.current.iTu+", "+this.props.editor.current.iSeg);
		if( (typeof(this.props.editor.current.iTu)!== 'undefined') && (typeof(this.props.editor.current.iSeg)!== 'undefined') ){
			editorService.addEditorPoi(this.props.orderRecord.id, name, description, this.props.editor.current.iTu, this.props.editor.current.iSeg)
			.then(()=>{return editorService.getEditorPois(this.props.orderRecord.id)})
			.then(response =>{this.setState({editorPois: response.data}); return 1})
			.catch(err => {/*console.log(err);*/});
		}
	}
	desmarcar(idMarca){
		editorService.deleteEditorPoi(idMarca);
		let newPois = this.state.editorPois.filter(function(poi){return poi.id!=idMarca});
		this.setState({editorPois: newPois});
	}
	
	validaSegment(index){
		if( typeof(this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg]["trg"]["state"])!=='undefined'
			&& this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg]["trg"]["state"] !== "translated"){
			let lstSegmentsMod=this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg];
			lstSegmentsMod["trg"]["state"]="translated";
			let translatedWords = editorService.updateWordCount(this.state.translatedWords, lstSegmentsMod, this.state.repetitions, this.state.indexSegments[index].iTu, this.state.indexSegments[index].iSeg);
			this.setState({translatedWords: translatedWords});
			this.updateSegment(lstSegmentsMod, index);
		}
		this.handleNext();
	}
	
	handleScroll(e) {
		const { scrollTop, scrollLeft } = e.target;
//		console.log("scroll event "+scrollTop+", "+scrollLeft);
	};
	
	wheel(e){
		e.preventDefault();
		e.stopPropagation();
		
//		let originalStyle = window.getComputedStyle(document.body).overflow;
//		document.body.style.overflow = "hidden";
		
//		console.log("wheel: "+e.deltaY);
		if(e.deltaY>0){
			this.handleNext();
		}else{
			this.handlePrev();
		}
//		document.body.style.overflow = originalStyle;
	}
	
	desbloquejaSegment(index){
		let lstSegmentsMod=this.props.editor.TUs[this.state.indexSegments[index].iTu].segments[this.state.indexSegments[index].iSeg];
		lstSegmentsMod["trg"]["state"]="new";
		this.updateSegment(lstSegmentsMod, index);
	}
	
	renderQaErrorsList(){
		if(typeof this.state.qaErrors.errors !== 'undefined' && this.state.qaErrors.errors.length>0){
			let activeErrors = this.state.qaErrors.errors.filter(error => error.enabled>0);
			let badSegments = [];
			let errorList=[];
			let segment;
			activeErrors.forEach((error,i) => { if(i>0){
													if(segment==error.tuNumber){
														errorList.push(i);
													}else{
														badSegments.push({segment: segment, errors: errorList});
														errorList=[];
														segment = error.tuNumber;
														errorList.push(i);
													}
												}else{
													errorList=[];
													segment = error.tuNumber;
													errorList.push(i);
												}
											});
			// Guarda la ultima iteració
			badSegments.push({segment: segment, errors: errorList});
			
//			console.log(activeErrors);
//			console.log(badSegments);
			
			return <QAErrorSlide errors={activeErrors}
								badSegments={badSegments}
								goToSegment={this.handleGotoSegmentIndex}/>
		}else{
			return "";
		}
	}
	
	handleSliderChange(e){
//		console.log(e);
//		console.log(e.y);
		let a = 100-(750/(e.y-240));
//		console.log(a);
	}
					
	render() {
		console.log("RENDER:");
//		console.log("props Editor.tmx:");
//		console.log(this.props.editor.tmx);
//		console.log("state Editor:");
//		console.log(this.state.glossary);
//		console.log(this.props.customerRecord);
		
		var first;
		var last;
		var indexCurrent=0;
		var linies = [];
		var pois = [];
		let MAX_CONTEXT=this.state.contextShown;
		let accio=null;
		let tmxMatch=0;
		let tmxDistance=0;
		let segmentDiff="";
		let sizeTmx=6;
		let sizeGlosari=6;
		let glossary = [];
		let glossaryMap = new Map();
		if(this.state.focus=="tmx"){
			sizeTmx=10;
			sizeGlosari=2;
		}
		let translatedWords = 0;
		let translatedNewWords = 0;
		let translatedRepWords = 0;
		let translatedM100 = 0;
		let translatedM75 = 0;
		
		let disableInvChars = this.state.spellErrors===null ? '' : 'disabled';
		let disableCorrector = this.state.showInvChars===0 ? '' : 'disabled';
		
		if(this.state.processing>0){
			return (<Box>PROCESSING...</Box>);
		}

		let replaceRepClass = (this.state.replaceRepetitions==1) ? "" : "activeButtonIcon";
		let invClass = (this.state.showInvChars>0) ? "activeButtonIcon" : "";
		let spellCheckClass = (this.state.spellErrors!==null) ? "activeButtonIcon" : "";
		if(typeof(this.props.editor.current)!== 'undefined'){
			let index = this.cercaIndexSegment(this.props.editor.current.iTu, this.props.editor.current.iSeg);
			if(typeof(this.props.editor.TUs) !== 'undefined' && typeof(this.state.indexSegments[index]) !=='undefined' && typeof(this.props.editor.TUs[this.state.indexSegments[index].iTu]) !== 'undefined' && typeof(this.props.editor.TUs[this.state.indexSegments[index].iTu]["segments"]) !== 'undefined'&& typeof(this.props.editor.TUs[this.state.indexSegments[index].iTu]["segments"][this.state.indexSegments[index].iSeg]) !== 'undefined' ){
				first = (index>MAX_CONTEXT)?index-MAX_CONTEXT:0;
				last = (index+MAX_CONTEXT<this.state.indexSegments.length)?index+MAX_CONTEXT+1:this.state.indexSegments.length;
				//first = 0;
				//last = this.state.indexSegments.length;
//				console.log("first: "+first+", last:"+last+", current:"+this.props.editor.current)
				for(let i=first; i<last; i++){
//					console.log("PINTA: "+i+"["+this.state.indexSegments[i].iTu+","+this.state.indexSegments[i].iSeg+"]");
					if( typeof(this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["ECL TMX"])!=='undefined' &&
						typeof(this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["ECL TMX"].matchQuality )!=='undefined'){
						tmxMatch = this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["ECL TMX"].matchQuality;
						tmxDistance = this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["ECL TMX"].distance;
						
						if(i===index && typeof(this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]['ECL TMX'].distance) !== 'undefined'){
							segmentDiff=<SegmentDiff
											distance = {this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["ECL TMX"].distance.distance}
											operations = {this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]["ECL TMX"].distance.operations}
										/>
						}
						
					}else{
						tmxMatch=0;
						tmxDistance=0;
					}
					if(i===index){
						indexCurrent=i;
					}
					/*
					if(i==index-1){
						accio=this.handlePrev;
					}else if(i==index+1){
						accio=this.handleNext;
					}else if(i!=index){
						//accio=null;
						accio=this.handleGotoSegment;
					}
					*/
					//linia = [];
					let isRepetition=typeof(this.state.repetitions.source[this.state.indexSegments[i].iTu])!=="undefined" && typeof(this.state.repetitions.source[this.state.indexSegments[i].iTu][this.state.indexSegments[i].iSeg]!="undefined") && this.state.repetitions.source[this.state.indexSegments[i].iTu][this.state.indexSegments[i].iSeg]!=null;
					let isRepetitionSrc=typeof(this.state.repetitions.target[this.state.indexSegments[i].iTu])!=="undefined" && typeof(this.state.repetitions.target[this.state.indexSegments[i].iTu][this.state.indexSegments[i].iSeg]!="undefined") && this.state.repetitions.target[this.state.indexSegments[i].iTu][this.state.indexSegments[i].iSeg]!=null;
					let spellErrors= this.state.spellErrors!==null ? this.state.spellErrors.filter(error => {if( (error.iTu == this.state.indexSegments[i].iTu)&&(error.iSeg == this.state.indexSegments[i].iSeg) ){ return true;}}) : null;
					
					let firstSpellErrorIndex = 0;
					while( (this.state.spellErrors!==null) && (firstSpellErrorIndex<this.state.spellErrors.length) && 
							((this.state.spellErrors[firstSpellErrorIndex].iTu !== this.state.indexSegments[i].iTu) || 
							 (this.state.spellErrors[firstSpellErrorIndex].iSeg !== this.state.indexSegments[i].iSeg))){
						firstSpellErrorIndex++;
					}
						
					linies.push(
						<EditorRow
							iTu = {this.state.indexSegments[i].iTu}
							iSeg = {this.state.indexSegments[i].iSeg}
							indexTotal = {i}
							indexParcial = {i-first}
							count = {this.state.indexSegments.length}
							current={i===index}
							accio={this.handleGotoSegment}
							tmxMatch={tmxMatch}
							tmxDistance={tmxDistance}
							isRepetition={isRepetition}
							isRepetitionSrc={isRepetitionSrc}
							showInvChars={this.state.showInvChars}
							tagSeleccionat={this.state.tagSeleccionat}
							segment={this.props.editor.TUs[this.state.indexSegments[i].iTu].segments[this.state.indexSegments[i].iSeg]}
							handleNext={this.handleNext}
							handleGotoSegment={this.handleGotoSegmentIndex}
							updateSegment={this.updateSegment}
							onSeleccionaTag={this.seleccionaTag}
							traspassaSegment={this.traspassaSegment}
							validaSegment={this.validaSegment}
							spellErrors={spellErrors}
							updateSpellError={this.updateSpellError}
							currentSpellError={typeof(this.state.currentSpellError)!="undefined" ? this.state.currentSpellError-firstSpellErrorIndex:0}
							firstSpellErrorIndex={firstSpellErrorIndex}
							//currentSpellError={typeof(this.state.currentSpellError)!="undefined" ? this.state.currentSpellError:0}
							editantParaula={this.state.editantParaula}
							handleGotoError={this.handleGotoError}
							desbloquejaSegment={this.desbloquejaSegment}
							//glossary={this.state.glossary}
						/>
					);
				}
			}
			if(typeof(this.state.editorPois)!== 'undefined'){
				for(let i=0; i<this.state.editorPois.length; i++){
					let index = this.getIndexSegment(this.state.editorPois[i].indexTu, this.state.editorPois[i].indexSeg);
//					console.log("indexSegment: "+index);
					let description = (this.state.editorPois[i].description!== 'undefined') ? this.state.editorPois[i].description : "";
					pois.push(
						<Grid item xs={12}>
							<Tooltip placement="left" title={description}><Box class="poi">
								<span class="poilabel" onClick={() => this.props.actions.gotoSegment(this.state.editorPois[i].indexTu, this.state.editorPois[i].indexSeg)}>({index+1}) {this.state.editorPois[i].name}</span>
								&nbsp;<span class="poidelete"> <HighlightOffOutlinedIcon style={{ fontSize: "16px", cursor: "pointer" }} onClick={() => this.desmarcar(this.state.editorPois[i].id)}/></span>
							</Box></Tooltip>
						</Grid>
					);
				}
			}
			if(this.state.glossary!==null){
				Object.entries(this.state.glossary).forEach(([key, value]) => {
					//let index = this.props.editor.TUs[this.state.indexSegments[indexCurrent].iTu].segments[this.state.indexSegments[indexCurrent].iSeg].src.text.toLowerCase().indexOf(key.toLowerCase());
					let regex = key.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
					var myRe = new RegExp(`\\b${regex}\\b`);
					let index = this.props.editor.TUs[this.state.indexSegments[indexCurrent].iTu].segments[this.state.indexSegments[indexCurrent].iSeg].src.text.toLowerCase().search(myRe);
					if(index>-1){
						if(glossaryMap.has(index)){
							if(glossaryMap.get(index).length<key.length){
								glossaryMap.set(index, key);
							}
						}else{
							glossaryMap.set(index, key);
						}
					}
					//newText[i].props.children=newText[i].props.children.replace(key, "<span class=\"glossary\">"+key+"</span>");
				});
				glossaryMap.forEach((value, key) => {
					glossary.push(<div class="glossary"><span class="src">{value}</span> : <span class="trg">{this.state.glossary[value].join(' / ')}</span></div>);
				});
			}
			
			translatedWords = this.state.translatedWords.noves + this.state.translatedWords.rep + this.state.translatedWords.m100 + this.state.translatedWords.m75;
			translatedNewWords = this.state.translatedWords.noves;
			translatedRepWords = this.state.translatedWords.rep;
			translatedM100 = this.state.translatedWords.m100;
			translatedM75 = this.state.translatedWords.m75;
		}

//		onKeyPress={this.handleKey}
//		<Grid item xs={1} spacing={0}>Title: {this.props.orderRecord.phase.find(phase => {if(phase.type == "SOURCE"){ return true;}}).document.filename}</Grid>
//		<Grid item xs={1} spacing={0}>{this.props.orderRecord.phase.find(phase => {if(phase.type == "SOURCE"){ return true;}}).user.customer.name}</Grid>
		let match100 = this.state.tmxMatch!=null ? this.state.tmxMatch.match100 : 0;
		let match75 = this.state.tmxMatch!=null ? this.state.tmxMatch.match95 + this.state.tmxMatch.match90 + this.state.tmxMatch.match85 + this.state.tmxMatch.match80 + this.state.tmxMatch.match75 : 0;
		let scroll = {width: '100%', height: 750};
		
		//console.log(this.state.height);
		//console.log(scroll);
		//scroll.height = this.state.height-370;
		//console.log(scroll);
//		console.log((indexCurrent/this.state.indexSegments.length)*100);
		return(
			<Grid container item direction="column" justify="flex-start" alignItems="stretch" spacing={0}>
				<Grid container item direction="row" justify="flex-start" alignItems="flex-start" xs={12} spacing={0}>
					<Box class="editorHeader" height="100%" >
						<Grid container spacing={0}>
							<Grid item xs={3} spacing={0}>{this.props.orderRecord.code}</Grid>
							<Grid item xs={3} spacing={0}>Words <span class="small">(R)</span>: <span class="valor">{this.props.orderRecord.wordCountTrs} <span class="small">( {this.props.orderRecord.repetitionsTrs} )</span></span> | <span class="valor">{this.props.orderRecord.wordCountTrs - translatedWords} <span class="small">( {this.props.orderRecord.repetitionsTrs-translatedRepWords} )</span></span></Grid>
							<Grid item xs={3} spacing={0}>TMX 100%: <span class="valor">{match100}</span> | <span class="valor">{match100-translatedM100}</span></Grid>
							<Grid item xs={3} spacing={0}>TMX 75%: <span class="valor">{match75}</span> | <span class="valor">{match75-translatedM75}</span></Grid>
						</Grid>
					</Box>
				</Grid>
				<Grid item xs={12} spacing={0}>
					{this.renderQaErrorsList()}
				</Grid>
				<Grid container item direction="row" justify="center" alignItems="stretch" xs={12} spacing={0}>
					<Grid item alignItems="stretch" xs={sizeTmx} spacing={0}>
						<TmxSearch
							downloadTmx = {this.downloadTmx}
							tmx = {this.props.editor.tmx}
						/>
					</Grid>
					<Grid item alignItems="stretch" xs={sizeGlosari} spacing={0}>
						<Box class="tmxSearch">
							<Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={0}>
								<Grid item xs={3} spacing={0}>GLOSARI</Grid>
								<Grid item spacing={0}>{glossary}</Grid>
							</Grid>
						</Box>
					</Grid>
				</Grid>
				<Grid item justify="flex-start" alignItems="flex-start" xs={12} spacing={0}>
					{segmentDiff}
				</Grid>
				<Grid container item direction="row" justify="center" alignItems="center" xs={12} spacing={0}>
					<Grid item xs={12}>
						<Box class="botonera">
							<Grid container item direction="row" justify="space-between" alignItems="center" xs={12} spacing={0}>
								<Grid item xs={6}>
									<Documentation
										customer={this.props.customerRecord}
										accessToken={this.props.user.access_token}
									/>
									<FullText
										editor={this.props.editor}
										repetitions={this.state.repetitions}
										action={this.handleGotoSegment}
									/>
									<Tooltip title="Invisible characters"><span class={invClass} style={{cursor: "pointer"}} onClick={this.switchCarInv}><IconButton color="inherit" aria-label="Invisible characters" disabled={disableInvChars}><InvisibleIcon/></IconButton></span></Tooltip>&nbsp;
									<Tooltip title="Spell check"><span class={spellCheckClass} style={{cursor: "pointer"}} onClick={this.spellcheck}><IconButton color="inherit" aria-label="Spell check" disabled={disableCorrector}><SpellcheckIcon /></IconButton></span></Tooltip>&nbsp;
									<Tooltip title="Check TAGS"><span style={{cursor: "pointer"}} onClick={this.comprovaTags}><IconButton color="inherit" aria-label="Spell check"><CodeIcon /></IconButton></span></Tooltip>&nbsp;
									<Tooltip title="Replace repetitions"><span class={replaceRepClass} style={{cursor: "pointer"}} onClick={this.switchReplaceRepetitions}><IconButton color="inherit" aria-label="Replace repetitions"><GridOffIcon/></IconButton></span></Tooltip>&nbsp;
									<Tooltip title="Save"><span style={{cursor: "pointer"}} onClick={this.guardarP}><IconButton color="inherit" aria-label="Save"><SaveIcon /></IconButton></span></Tooltip>&nbsp;
									<Tooltip title="Save and Finalize"><span style={{cursor: "pointer"}} onClick={this.finalizar}><IconButton color="inherit" aria-label="Save and Finalize"><FinalizeIcon /></IconButton></span></Tooltip>
									<span>Context <input type="text" size="4" value={this.state.contextShown} onChange={this.onChangeContext} /></span>
									<Tooltip title="Marca"><span style={{cursor: "pointer"}} onClick={this.marcar}><IconButton color="inherit" aria-label="Marca"><LocationOnIcon /></IconButton></span></Tooltip>
									<span><input type="text" size="15" value={this.state.textMarca} onChange={this.onChangeTextMarca} /></span>
								</Grid>
								<Grid item xs={6}>
									<EditorSearch
										foundSegments={this.state.foundSegments}
										gotoSegment={this.handleGotoSegmentIndex}
										search = {this.search}
										replace = {this.replace}
									/>
								</Grid>
							</Grid>
						</Box>
					</Grid>
				</Grid>
				<Grid container item direction="row" justify="flex-start" alignItems="flex-start" xs={12} spacing={0}>
					<Grid container onWheel = {(e) => this.wheel(e)} item direction="column" justify="flex-start" alignItems="flex-start" xs={11} spacing={0}>
						{linies}
					</Grid>
					<Grid container item direction="row" justify="flex-start" alignItems="flex-start" xs={1} spacing={0}>
						<Grid item xs={1}>
							<Box class="slider-editor">
								<Slider
									orientation="vertical"
									value={100-(((indexCurrent+1)/this.state.indexSegments.length)*100)}
									aria-labelledby="vertical-slider"
									onChange={this.handleSliderChange}
								/>
							</Box>
						</Grid>
						<Grid container item direction="column" justify="flex-start" alignItems="flex-end" xs={11} spacing={0}>
							{pois}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		);
	}
}

function mapStateToProps(state, ownProps) {
	//console.log("state TMX: "+JSON.stringify(state.editor.tmx));
	//return {editor: state.editor, user: state.user, orderRecord: state.orders.find(ord => {if(ord.id == ownProps.match.params.idOrder){ return true;}})};
	//this.props.orderRecord.user.customer.id
	return{	editor: state.editor,
			user: state.user,
			orderRecord: state.orders[ownProps.match.params.idOrder],
			customerRecord: state.customers[state.users[state.orders[ownProps.match.params.idOrder].user].customer],
			langPair: state.languagePairs[state.orders[ownProps.match.params.idOrder].langPair],
	};
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(editorActions, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(EditorContainer);  